import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

function Breadcrumbs({ rootPath, subPath }) {
  return rootPath ? (
    <Breadcrumb style={{ backgroundColor: '#eee' }}>
      <Breadcrumb.Item active>
        {rootPath && rootPath.uri ? (
          <NavLink to={rootPath.uri}>{rootPath.name}</NavLink>
        ) : (
          rootPath.name
        )}
      </Breadcrumb.Item>

      {subPath &&
        subPath.map((path) => (
          <Breadcrumb.Item active key={path.name}>
            {path.uri ? (
              <NavLink to={path.uri}>{path.name}</NavLink>
            ) : (
              path.name
            )}
          </Breadcrumb.Item>
        ))}
    </Breadcrumb>
  ) : null;
}

Breadcrumbs.propTypes = {
  rootPath: PropTypes.shape({
    name: PropTypes.string,
    uri: PropTypes.string,
  }).isRequired,
  subPath: PropTypes.arrayOf(PropTypes.object),
};

export default Breadcrumbs;
